import axiosInstance from "../../app/apiClient";
import { ReportAdminService } from "../model/report.model";

const statisticsOrderByDay = (
	type: string,
	fromDate: string,
	toDate: string,
	kitchenId: number,
	isDetail: number
) =>
	axiosInstance.get(
		`api/v1/report/statisticsOrderByDay?type=${type}&fromDate=${fromDate}&toDate=${toDate}&kitchenId=${kitchenId}&isDetail=${isDetail}`,
		{
			responseType: "blob",
		}
	);
const searchStatisticsOrderByDay = (
	type: string,
	fromDate: string,
	toDate: string,
	kitchenId: number
) =>
	axiosInstance.get(
		`api/v1/report/statisticsOrderByDay?type=${type}&fromDate=${fromDate}&toDate=${toDate}&kitchenId=${kitchenId}`
	);
const feedbacks = (
	type: string,
	fromDate: string,
	toDate: string,
	kitchenId: number
) =>
	axiosInstance.get(
		`api/v1/report/feedbacks?type=${type}&fromDate=${fromDate}&toDate=${toDate}&kitchenId=${kitchenId}`,
		{
			responseType: "blob",
		}
	);
const searchFeedbacks = (
	type: string,
	fromDate: string,
	toDate: string,
	kitchenId: number
) =>
	axiosInstance.get(
		`api/v1/report/feedbacks?type=${type}&fromDate=${fromDate}&toDate=${toDate}&kitchenId=${kitchenId}`
	);
const questions = (
	type: string,
	fromDate: string,
	toDate: string,
	isDetail: number
) =>
	axiosInstance.get(
		`api/v1/report/questions?type=${type}&fromDate=${fromDate}&toDate=${toDate}&isDetail=${isDetail}`,
		{
			responseType: "blob",
		}
	);
const questionsExport = (type: string, fromDate: string, toDate: string) =>
	axiosInstance.get(
		`api/v1/questions/statistics/export/excel?type=${type}&fromDate=${fromDate}&toDate=${toDate}`,
		{
			responseType: "blob",
		}
	);
const searchQuestions = (type: string, keyword: string) =>
	axiosInstance.get(
		`api/v1/questions/statistics?type=${type}&keyword=${keyword}`
	);
const searchStatisticsPaymentByDay = (
	fromDate: string,
	toDate: string,
	kitchenId: number
) =>
	axiosInstance.get(
		`api/v1/report/statisticsPaymentByDay?fromDate=${fromDate}&toDate=${toDate}&kitchenId=${kitchenId}`
	);
const getQuestionStatistics = (id: number) =>
	axiosInstance.get(`api/v1/questions/${id}/answer/statistics`);
const getQuestionStatisticsExcel = (id: number) =>
	axiosInstance.get(`api/v1/questions/${id}/answer/statistics/export/excel`, {
		responseType: "blob",
	});
const report: ReportAdminService = {
	statisticsOrderByDay,
	searchStatisticsOrderByDay,
	feedbacks,
	searchFeedbacks,
	questions,
	searchQuestions,
	searchStatisticsPaymentByDay,
	getQuestionStatistics,
	getQuestionStatisticsExcel,
	questionsExport,
};

export default report;
